// import store from "../store/index";

import {getSiteInfo} from '@/utils/api'

/**
 * 获取站点信息
 */
function siteInfo(params,succCallback,errCallback) {
    let siteInfo = getSession('setSiteInfoByStore') || '';
    if(siteInfo){
        console.log('store-siteInfo:',siteInfo)
        succCallback(siteInfo);
        return;
    }
    getSiteInfo(params).then(res => {
        console.log('站点信息1',res.data);
        if(res.data.status === 200){
            //全局状态管理
            setSession('setSiteInfoByStore',res.data.data)
            succCallback(res.data.data);
        }else{
            errCallback(res.data)
        }
    })
}

function setSession(key, value) {
    if (typeof value === 'object') {
        value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
}

function getSession(key, defaultValue) {
    const value = sessionStorage.getItem(key);
    if (value !== null) {
        return JSON.parse(value);
    }
    return defaultValue;
}

export default {
    siteInfo,
    setSession,
    getSession
}

